import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadDrugs: -1,
  },
  drugs: [],
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.PRESCRIPTION_GET_DRUGS_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDrugs: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_GET_DRUGS_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          loadDrugs: 1,
        },
        drugs: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_DRUGS_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDrugs: 2,
        },
        error,
      };
    default:
      return state;
  }
}
